import React from 'react'
import "./languages.css"
import Glidar from '../../../components/Glidar'

const banksArr = [
    "../../../../img/lang/c++.svg",
    "../../../../img/lang/java.svg",
    "../../../../img/lang/python.svg",
    "../../../../img/lang/goLang.svg",
    "../../../../img/lang/cSharp.svg",
    "../../../../img/lang/js.svg",
    "../../../../img/lang/kotlin.svg"

]

function Languages() {
  return (
    <section className='languages_Section'>
        <h1 className='main-text'>Languages</h1>
        <Glidar animationDuration={banksArr?.length+"s"}  content={banksArr} headerColor={"linear-gradient(to bottom right, #32d6fb 0%, #5558ed 100%)"} style={{marginTop: "50px"}} />

    </section>
  )
}

export default Languages